import FormGroup from '../../generic/FormGroup';
import type { ServiceAuthenticationType, ServiceElementResponseAPI } from '../../../types/service';
import VariablePicker from '../../generic/environmentVariablePicker/VariablePicker';

interface BasicAuthConfigurationProps {
    userName: string | undefined | null;
    password: string | undefined | null;
    authenticationType: ServiceAuthenticationType;
    setNewServiceDetails: (data: ServiceElementResponseAPI) => void;
    serviceData: ServiceElementResponseAPI;
    isEnvironmentsEnabled: boolean;
}

const BasicAuthConfiguration = ({
    userName,
    password,
    authenticationType,
    setNewServiceDetails,
    serviceData,
    isEnvironmentsEnabled,
}: BasicAuthConfigurationProps) =>
    authenticationType === 'BASIC' ? (
        <>
            <p>
                Provide a username and password if requests to the connector URL require
                authentication. This is optional.
            </p>
            <FormGroup htmlFor="basic-auth-username" label="Username">
                <VariablePicker
                    onSelect={(variableName: string) =>
                        setNewServiceDetails({
                            ...serviceData,
                            httpAuthenticationUsername: variableName,
                        })
                    }
                    isVisible={isEnvironmentsEnabled}
                >
                    <input
                        id="basic-auth-username"
                        className="form-control form-control-long"
                        onChange={({ target }) =>
                            setNewServiceDetails({
                                ...serviceData,
                                httpAuthenticationUsername: target.value,
                            })
                        }
                        value={userName ?? ''}
                        required
                    />
                </VariablePicker>
            </FormGroup>
            <FormGroup htmlFor="basic-auth-password" label="Password">
                <VariablePicker
                    onSelect={(variableName: string) =>
                        setNewServiceDetails({
                            ...serviceData,
                            httpAuthenticationPassword: variableName,
                        })
                    }
                    isVisible={isEnvironmentsEnabled}
                >
                    <input
                        id="basic-auth-password"
                        className="form-control form-control-long"
                        onChange={({ target }) =>
                            setNewServiceDetails({
                                ...serviceData,
                                httpAuthenticationPassword: target.value,
                            })
                        }
                        value={password ?? ''}
                        type="password"
                        required
                    />
                </VariablePicker>
                <span className="help-block">
                    Previously added connector passwords are not shown in this field
                </span>
            </FormGroup>
        </>
    ) : null;

export default BasicAuthConfiguration;
